import { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import CollectionForPersonalizationBlock from 'products/CollectionForPersonalizationBlock';
import ClubMembershipForPersonalizationBlock from 'profile/clubMembership/ClubMembershipForPersonalizationBlock';
import SubscribeForm from 'profile/subscribe/SubscribeForm';
import { getPersonalizationBlock } from 'redux/personalizationBlock/actions';
import { getPersonalizationBlockByCode } from 'redux/personalizationBlock/reducers';

class PersonalizationBlock extends Component {
  componentDidMount() {
    const { props } = this;
    props.getPersonalizationBlock(props.code);
  }

  render() {
    const { settings, personalizationBlock, node } = this.props;
    if (!settings.data || !personalizationBlock || !personalizationBlock.code) {
      return null;
    }
    // Remove min-height after loaded
    node.style.minHeight = 0;
    if (!personalizationBlock.content) {
      return null;
    }
    if (personalizationBlock.type === 'Product Collection') {
      const { slug } = personalizationBlock.products.collection;
      return ReactDOM.createPortal(
        <>
          <div
            dangerouslySetInnerHTML={{ __html: personalizationBlock.content }}
          />
          <div
            className="c7-product-collection c7-product-collection-personalization"
            style={{ minHeight: 0 }}
          >
            <CollectionForPersonalizationBlock collectionSlug={slug} />
          </div>
        </>,
        node
      );
    }
    if (personalizationBlock.type === 'Subscribe Form') {
      return ReactDOM.createPortal(
        <>
          <div
            dangerouslySetInnerHTML={{ __html: personalizationBlock.content }}
          />
          <div className="c7-subscribe c7-subscribe-personalization">
            <SubscribeForm hasNameFields />
          </div>
        </>,
        node
      );
    }
    if (personalizationBlock.type === 'Club Shipment') {
      return ReactDOM.createPortal(
        <>
          <div
            dangerouslySetInnerHTML={{ __html: personalizationBlock.content }}
          />
          <ClubMembershipForPersonalizationBlock />
        </>,
        node
      );
    }
    return ReactDOM.createPortal(
      <>
        <div
          dangerouslySetInnerHTML={{ __html: personalizationBlock.content }}
        />
      </>,
      node
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  personalizationBlock: getPersonalizationBlockByCode(
    state.personalizationBlock,
    ownProps.code
  ),
  settings: state.setting
});

export default connect(mapStateToProps, {
  getPersonalizationBlock
})(PersonalizationBlock);
